import { fg } from '@atlassian/jira-feature-gating';

const JiraTeamButtonRelayProvider = {
	get(): boolean {
		return (
			// eslint-disable-next-line jira/ff/no-preconditioning
			fg('team-connection-visibility-in-jira')
		);
	},
};

export default JiraTeamButtonRelayProvider;
